"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatStreamEventType = exports.ChatMessageRole = void 0;
/**
 * Enums
 */
var ChatMessageRole;
(function (ChatMessageRole) {
    ChatMessageRole["USER"] = "user";
    ChatMessageRole["ASSISTANT"] = "assistant";
})(ChatMessageRole || (exports.ChatMessageRole = ChatMessageRole = {}));
var ChatStreamEventType;
(function (ChatStreamEventType) {
    ChatStreamEventType["MESSAGE_START"] = "message_start";
    ChatStreamEventType["CONTENT_BLOCK_START"] = "content_block_start";
    ChatStreamEventType["CONTENT_BLOCK_DELTA"] = "content_block_delta";
    ChatStreamEventType["CONTENT_BLOCK_STOP"] = "content_block_stop";
    ChatStreamEventType["MESSAGE_DELTA"] = "message_delta";
    ChatStreamEventType["MESSAGE_STOP"] = "message_stop";
    ChatStreamEventType["ERROR"] = "error";
    ChatStreamEventType["COMPLIANCE_UPDATE"] = "compliance_update";
})(ChatStreamEventType || (exports.ChatStreamEventType = ChatStreamEventType = {}));
